import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ISearchForm } from '../_models/search';
import { SearchService } from '../_services/search.service';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { DocumentService } from '../_services/document.services';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { AlertService } from '../_services/alert.service';
import { saveAs } from 'file-saver';
import { HttpClient } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { filter } from 'rxjs/operators';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { Document } from 'src/app/_models/document';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSelectChange } from '@angular/material/select';
import { PopUpComponent } from '../common/pop-up/pop-up.component';
import { COMMENT_APPENDER, COMMENT_APPLICABLE_METADATA_KEYS, MAX_CHARS, PORTAL_USER_INFO_KEY } from '../constants/portal-user-info';
import { MARK_FOR_DELETE_KEY, REASON_FOR_DELETE_KEY, REASON_FOR_DELETE_PROMPT } from '../constants/mark-for-delete';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { element } from 'protractor';

class SearchCriterion {
  bindingName: string;
  value: string;
}

interface ApplicableMetadataComments {
  metadataName: string;
  comment: string
}

@Component({
  selector: 'app-legacy-index',
  templateUrl: './legacy-index.component.html',
  styleUrls: ['./legacy-index.component.scss'],
  providers: [DatePipe]
})
export class LegacyIndexComponent implements OnInit {
  searchResultsList: MatTableDataSource<any>;
  selection: SelectionModel<any>;  
  width: String = "100";
  appError: String = "";
  noSearchForms: boolean = false;
  archive: boolean;
  indexDocList: MatTableDataSource<any>;
  documentCount: number = 0;
  noDocuments: boolean = true;
  category: any;
  documents: any;
  categoryID: any;  
  isCategorySelected: boolean = false;
  categoryMetaData: any;
  pagesForm: FormGroup;  
  isValidCallInProgress = false;
  filterInput: string = "";
  selectedColumnList: string[] = [];
  isExportLink: boolean = false;

  pageSize = 50;
  pageIndex = 0;
  currentPageSize = 0;
  currentStartPageIndex = 0;

  paginator;
  @ViewChild(MatPaginator, { static: false }) set pageContent(content: any) {
    this.paginator = content;
    if (this.paginator) {
      this.indexDocList.paginator = this.paginator;
    }
  }

  events: string[] = [];
  opened: boolean;

  constructor(
    private apiSvc: SearchService,
    private cdref: ChangeDetectorRef,    
    private documentService: DocumentService,    
    public dialog: MatDialog,    
    private fb: FormBuilder,
    private alertService: AlertService,
    private httpClient: HttpClient,
    private datePipe: DatePipe,
    private snackBar: MatSnackBar,
  ) { }

  searchForms:any = [];
  tempForms:any = [];
  columnFilterCriteria = [];
  searchResults: Array<JSON> = [];
  selectedForm: ISearchForm;  
  limit: number = 200;
  headerColumns = [];
  offset: number = 0;
  loadNext: boolean = false;
  loadPrevious: boolean = false;
  selectedDoc: any;
  allSearchForms: any
  noSearchResults: boolean = false;  
  isCaseInsensitive: boolean = true;
  showArchived: boolean = false;
  filterValue: string = "";
  savedSearchQueries: any;
  isFilterSearchEnabled: boolean = false;
  formId: number;
  searchCtrl: string = "";  
  pagesArray = [];  
  tableData: any;
  values: any[];  
  propertyKeys: String[] = [];
  properties: any;
  paginationPagesArray = [];
  displayList = [];
  totalSize = 0;
  filterTotalSize = 0;
  staticColumns : string[] =  ["Subject", "Key Date", "Document Type", "Water Right ID"];
  additionalColumns : any[] = [];
  openMetaData: boolean = false;
  hideDocView: Boolean = false;
  activeDocumentDetails: Document = null;
  isAdmin: Boolean = false
  isBulkUpdateAsyncLimit: number = 0;
  BULK_LIMIT_KEY: string = "BULK_UPDATE_LIMIT";
  isExportMetaDataCsv: boolean = false;
  exportExpiration: number = 60;
  searchCriteria: any;
  comment: string = "";
  portalUserInfo: any = {};
  portalUserInfoByDocumentId: any[] = [];
  reasonForDeleteByDocumentId: any[] = [];
  latestComments: ApplicableMetadataComments[] = [];
  counties: string = "";

  ngOnInit(): void {
    this.documentService.bulkMetadataSearchForms().subscribe(forms => {
      this.searchForms = forms[0];
      this.selectedForm = this.searchForms;
      this.selectedForm.form.forEach(form => {
        form.values = ""
      })
      this.tempForms = forms[0];
      this.displayList = JSON.parse(this.searchForms.display_list);
    }, error => {
      this.alertService.error("Server error, form is not loading");
    });
    this.documentService.getConfigurationByKey(this.BULK_LIMIT_KEY).subscribe(values => {
      this.isBulkUpdateAsyncLimit = Number(values[this.BULK_LIMIT_KEY]);
    }, error => {
      this.alertService.error("Server error, settings is not loading");
    });
    this.selection = new SelectionModel(true, this.pagesArray);
    this.isAdmin = JSON.parse(localStorage.getItem("isAdmin"));
  }

  ngAfterContentChecked() {
    //this.selectedRow = undefined
    this.cdref.detectChanges();
  }

  resetForms() {
    this.searchForms = this.tempForms;
    this.columnFilterCriteria = [];
    this.pagesArray = [];
    this.paginationPagesArray = [];
    this.pageIndex = 0;
    this.pageSize = 50;
    this.currentStartPageIndex = 1;
    this.currentPageSize = 50;
    this.indexDocList = null;
    this.documentCount = 0;
    this.totalSize = 0;
    this.filterTotalSize = 0;
    this.noDocuments = true;
    this.deselectAll();
  }

  checkAllSelectedRowsValid(updateList) {
    let isValidData = true;
    updateList.forEach((element, index) => {
      let originalDocumentID = element.document_id;
      element['objValues'].forEach(property => {
          if (property.name == 'Water Right ID' && property["error"]["flag"]) {
            isValidData = false;
          } else if (property.name == 'Parent Doc ID' && property["error"]["flag"]) {
            isValidData = false;
          } else if (property.name == 'Parent Doc ID' && originalDocumentID === property.value) {
            property["error"] = {
              "flag": true,
              "message": "Cannot map original document ID as parent"
            }
            isValidData = false;
          }
      });
    });
    return isValidData;
  }

  save() {
    if (this.selection.selected.length == 0) {
      this.alertService.error("Please select documents to update");
            setTimeout(() => {              
            }, 2000);
      return;
    }
    if (this.isValidCallInProgress) {
      this.alertService.success("Metadata validation is in progress, please try again");
            setTimeout(() => {              
            }, 2000);
      return;
    }
    if (this.selection.selected.length > this.isBulkUpdateAsyncLimit && !this.isAdmin){
      this.alertService.success("Document count for update has exceeded the limit of " + this.isBulkUpdateAsyncLimit + ". Please contact administrator to perform this operation.");
            setTimeout(() => {              
            }, 2000);
      return;
    }
    // add if condition - if records more than 10k and not admin then raise exception
    let selectedList = this.selection.selected;
    let updateList = selectedList.filter(row => this.pagesArray.map(value => value.document_id).includes(row.document_id));
    let isValidData = this.checkAllSelectedRowsValid(updateList);
    if (!isValidData) {
      this.alertService.error("Please resolve the metadata validation error");
    } else {      
      let records = [];
      
      updateList.forEach((element, index) => {
        let properties = {};
        element['objValues'].forEach(property => {
          if (property.data_type === "date") {
            if (property.visible) {
              if (property.value) {
                const editField = new Date(property.value);          
                let dateString = this.datePipe.transform(editField, 'MM/dd/yyyy');
                property.value = dateString;
                properties[property.name] = dateString;                
              } else{
                properties[property.name] = property.value;
              }
            } else {
              if (property.value && property.value != "") {
                const editField = new Date(property.value);          
                let dateString = this.datePipe.transform(editField, 'MM/dd/yyyy');
                property.value = dateString;
                properties[property.name] = dateString;
              }
            }
          }
          else if (property.data_type === "int") {
            if (property.visible) {
              property.value = parseInt(property.value);
              properties[property.name] = parseInt(property.value);
            }
          }
          else if (property.data_type == "bool") {
            if (property.visible) {
              properties[property.name] = property.value
              if (property.value !== true) {
                property.value = false;
                properties[property.name] = false;
              }
            } else {
              if (property.name == "Public Search") {
                properties[property.name] = false;
              }
            }
          }
          else if (property.name == 'Water Right ID') {
            let wrIds = [];
            if (property.value) {
              let wrList = property.value.split(",");
              for (var index in wrList) {
                wrIds.push(wrList[index].trim());
              }
            }
            if (wrIds.length > 0) {
              properties[property.name] = wrIds;
            }
          }
          else if (property.name == 'Document Type') {
            let selectedDocumentType = '';
            let filterList = property.values.filter(obj => obj.DocumentType === property.value);
            if (property.value) {
              let docTypes = property.value.split(">");
              selectedDocumentType = docTypes[2];
            }
            properties[property.name] = selectedDocumentType.trim();
            if (filterList.length > 0) {
              properties['category_id'] = filterList[0].CategoryId;
            }
          } else if (property.name == PORTAL_USER_INFO_KEY) {
            if (this.portalUserInfoByDocumentId.length > 0) {
              const portalUserInfo = this.portalUserInfoByDocumentId.find(obj => Object.keys(obj).includes(element.document_id));
              if (portalUserInfo && Object.keys(portalUserInfo).length > 0) {
                const [innerData] = Object.values(portalUserInfo)
                properties[property.name] = innerData
              }
            }
          } else if (property.name == REASON_FOR_DELETE_KEY) {
            let markForDelete = element['objValues'].find(key => key.name === MARK_FOR_DELETE_KEY);
            if (this.reasonForDeleteByDocumentId.length > 0 && markForDelete.value == true) {
              const reasonForDelete = this.reasonForDeleteByDocumentId.find(obj => Object.keys(obj).includes(element.document_id));
              if (reasonForDelete && Object.keys(reasonForDelete).length > 0) {
                properties[property.name] = reasonForDelete[element.document_id]
              }
            }
          } else {
            if (property.visible && !(property.name == 'Document Title' || property.name == 'Document ID')) {
              properties[property.name] = property.value;
            } else {
              if (property.value && property.value != "") {
                properties[property.name] = property.value;
              }
            }        
          }
        });

        var recordIndex = {
          "searchQuery": {"docId": element.document_id},
          "updateValues": properties
        }
        records.push(recordIndex);      
      });
      let criteria = [];
      let asyncUpdate = false;
      if (records.length > this.isBulkUpdateAsyncLimit) { 
        asyncUpdate = true;
        this.displayList.forEach(data => {
          if (data['values'] && data['values'] !== "") {          
            let filterList = this.searchForms.form.filter(form => form['label'].toLowerCase().includes(data['Property Name'].toLowerCase()));
            let filterCriteria = filterList[0];
            var d = JSON.parse(JSON.stringify(data))
            var criterion = new SearchCriterion();
            criterion.bindingName = filterCriteria.bindingName;
            criterion.value = d.values;
            criterion["case_insensitive"] = this.isCaseInsensitive;
            if (filterCriteria.UIControl == "Date") {
              var dateArray = criterion.value.split("-");
              var date = dateArray[1] + "/" + dateArray[2] + "/" + dateArray[0];
              criterion.value = date;
            }
            if (d.Type == 'bool') {
              criterion.value = "" + criterion.value;
            }
            //criterion["case_insensitive"]= false;
            criteria.push(criterion);
          }
        });
      }
      var request = {
         "operationType": "update",     
         "taskQueue": records,
         "async": asyncUpdate,
         "source": "ECM",
         "criteria": criteria,
         "ignore_locked_status": true
      }
      this.documentService.updateMetadata(request)
        .subscribe(resp => {
          if (this.selection.selected.length > this.isBulkUpdateAsyncLimit && this.isAdmin){
            this.snackBar.open(
              "Bulk update request is running in the background. The status of bulk update can be tracked from 'Status' tab",
              'Close',
              {
                duration: 10000,
              }
            );
          } else {
            this.alertService.success("Documents are updated successfully");
          }
          setTimeout(() => {
            this.selectedColumnList = [];
            this.executeSearch(this.limit, this.offset, false);
          }, 2000);
        }, error => {
            console.log(error);
            this.selectedColumnList = [];
            this.alertService.error(error.error.message);
            setTimeout(() => {
              this.deselectAll();
              this.alertService.clear();
            }, 5000);
        }
      );
    }
    this.resetComments();
  }

  updateList(documentId: string, documentIndex: number, propertyIndex: number, property: any, event: any) {
    var editField;
    if (event instanceof MatSelectChange)
      editField = event.value;
    else if (event instanceof MatSlideToggleChange)
      editField = event.checked
    else
      editField = event.target.value;
    this.pagesArray[documentIndex].objValues[propertyIndex].value = editField;
    var originalDocumentID = this.pagesArray[documentIndex].document_id;
    var name = property.name;
    let isValidData = false;
    let parentFlagList = this.pagesArray[documentIndex].objValues.filter(object => object.name == 'Parent');
    let parentFlagObject = undefined;

    if (COMMENT_APPLICABLE_METADATA_KEYS.includes(name)) {
      this.openDialog(name, documentId, this.pagesArray[documentIndex])
    } else if (MARK_FOR_DELETE_KEY === name) {
      if (editField)
        this.openDeleteDialog(this.pagesArray[documentIndex])
    }

    if (parentFlagList.length > 0) {
      parentFlagObject = parentFlagList[0];
    }
    if (editField && editField !== "") {
      if (name == 'Water Right ID') {
        let wrIds = [];
          if (editField) {
            let wrList = editField.split(",");
            for (var index in wrList) {
              wrIds.push(wrList[index].trim());
            }
          }
          var request = {
            "value": wrIds,
            "key": 'WR_ID'
          }
          this.isValidCallInProgress = true;
          this.documentService.validateMetadata(request).subscribe(resp => {
            if (resp) {            
              for (var i in wrIds) {
                if (resp[wrIds[i]]) {
                  isValidData = true;
                } else {
                  isValidData = false;                
                }
              }
              if (!isValidData) {
                property["error"] = {
                  "flag": true,
                  "message": "Please enter a valid " + name
                }
              } else {
                property["error"] = {
                  "flag": false,
                  "message": ""
                }
              }
            }
            this.isValidCallInProgress = false;
          }, error => {
            console.log(error);
            this.isValidCallInProgress = false;
          });
      } else if (name == 'Parent Doc ID') {
          let docIds = [];
          if (parentFlagObject) {
            parentFlagObject.disabled = false;
          }            
          if (editField) {
            let docList = editField.split(",");
            for (var index in docList) {
              docIds.push(docList[index].trim());
            }
          }
          if (originalDocumentID === editField) {
            property["error"] = {
              "flag": true,
              "message": "Cannot map original document ID as parent"
            }
          }
          else if (docIds.length > 1) {
            property["error"] = {
              "flag": true,
              "message": "Cannot map multiple parent document ID"
            }
          } else {
            property["error"] = {
              "flag": false,
              "message": ""
            }
            var request = {
              "value": docIds,
              "key": 'DOC_ID'
            }
            this.isValidCallInProgress = true;
            this.documentService.validateMetadata(request).subscribe(resp => {
              if (resp) {            
                for (var i in docIds) {
                  if (resp[docIds[i]]) {
                    isValidData = true;
                  } else {
                    isValidData = false;                
                  }
                }
                if (!isValidData) {
                  property["error"] = {
                    "flag": true,
                    "message": "Please enter a valid " + name
                  }
                } else {
                  property["error"] = {
                    "flag": false,
                    "message": ""
                  }
                  if (parentFlagObject) {
                    parentFlagObject.disabled = true;
                    parentFlagObject.value = false;
                  } 
                }
              }
              this.isValidCallInProgress = false;
            }, error => {
              console.log(error);
              this.isValidCallInProgress = false;
            });
          }
      } 
    } else {
      property["error"] = {
        "flag": false,
        "message": ""
      }
      if (parentFlagObject) {
        parentFlagObject.disabled = false;
      } 
    }
    if (name == "Key Date") {
      if (editField) {
        const d = new Date(editField);
        const currentDate = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1);
        let dateString = this.datePipe.transform(currentDate, 'yyyy-MM-dd');
        let dateStrFormat = dateString.split("-");
        var list = this.pagesArray[documentIndex].objValues.filter((obj) => obj.name == "Key Year");
        if (list && list.length > 0) {
          list[0].value = dateStrFormat[0];
        }        
        property.value = dateString;
        property["error"] = {
            "flag": false,
            "message": ""
        }      
      } else {
        property["error"] = {
            "flag": true,
            "message": "Date is invalid"
        }
      }
    }
    if (name == "Key Year") {
      if (editField) {
        if (isNaN(editField) || editField.length > 4 || editField.length < 4) {
          property["error"] = {
            "flag": true,
            "message": "Please enter a valid key year"
          }
        } else {
          property["error"] = {
            "flag": false,
            "message": ""
          }
        }
      }
    }
  }

  trackByIndex(index, item) {
    return item.id;
  }

  checkboxLabel(row?: any): string {
    //this.docIdArray = true
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row 
    ${row.position + 1}`;
  }

  public onCheckAllChange(event: Event): void {
    const isChecked = (event.target as HTMLInputElement).checked;
    if (isChecked) {
      this.selectAll();
    } else {
      this.deselectAll();
    }
  }

  private selectAll(): void {
    this.selection.select(...this.pagesArray);
  }

  private deselectAll(): void {
    this.selection.clear();
  }

  filterSearch(filterValue, column) {      
      this.documentCount = 0;
      this.documents = [];            
      //populate search request
      
      this.offset = 0;
      let searchCriteria = [];
      
      var nextSearchReq = {
        "searchformId": String(this.searchForms.id),
        "limit": 200,
        "offset": this.offset,
        "storage_class": "S3",
        "criteria": []
      };

      if (this.showArchived) {
        nextSearchReq.storage_class = "Glacier";
      }
      searchCriteria.push(nextSearchReq.criteria)
      this.displayList.forEach(data => {
        if (data['values'] && data['values'] !== "") {          
          let filterList = this.searchForms.form.filter(form => form['label'].toLowerCase().includes(data['Property Name'].toLowerCase()));
          let filterCriteria = filterList[0];
          var d = JSON.parse(JSON.stringify(data))
          var criterion = new SearchCriterion();
          criterion.bindingName = filterCriteria.bindingName;
          criterion.value = d.values;
          criterion["case_insensitive"] = this.isCaseInsensitive
          if (filterCriteria.UIControl == "Date") {
            var dateArray = criterion.value.split("-")
            var date = dateArray[1] + "/" + dateArray[2] + "/" + dateArray[0]
            criterion.value = date
          }
          if (d.Type == 'bool') {
            criterion.value = "" + criterion.value;
          }
          //criterion["case_insensitive"]= false;
          nextSearchReq.criteria.push(criterion);
        }
      }); 
      
      if (this.columnFilterCriteria.length > 0) {
          this.columnFilterCriteria.forEach(crit => {
            if (crit.bindingName.toLowerCase() == column.toLowerCase()) {
              crit.value = filterValue;
            } else {            
              nextSearchReq.criteria.push(crit);
            }
          });
      }

      if (this.filterValue || this.filterValue !== "") {
        let checkSavedQueries = this.columnFilterCriteria.filter(fc => fc.bindingName.toLowerCase() === column.toLowerCase() && fc.value.toLowerCase() === filterValue.toLowerCase());
        if (checkSavedQueries.length == 0) {
          let filterList = this.searchForms.form.filter(form => form['label'].toLowerCase().includes(column.toLowerCase()));
          let filterCriteria = filterList[0];     
          var criterion = new SearchCriterion();
          criterion.bindingName = filterCriteria.bindingName;
          criterion.value = filterValue;
          criterion["case_insensitive"] = this.isCaseInsensitive;
          if (filterCriteria.UIControl == "Date") {
            var dateArray = criterion.value.split("-");
            var date = dateArray[1] + "/" + dateArray[2] + "/" + dateArray[0];
            criterion.value = date;
          }
          this.columnFilterCriteria.push(criterion);        
          nextSearchReq.criteria.push(criterion);
        } else {
          let criterion = checkSavedQueries[0];
          nextSearchReq.criteria.push(criterion);
        }
      } else {
        if (this.columnFilterCriteria.length == 0) {
          this.isFilterSearchEnabled = false;
        }
      }

      this.apiSvc.getSearchResults(nextSearchReq)
      .subscribe(resp => {
        console.log("Response", resp)
        if (resp.body == "No search results found") {
          this.alertService.error("No documents found");
        }
        else {
          this.noDocuments = false;
          this.noSearchResults = false;
          this.documents = resp.body;
          this.filterTotalSize = Number(resp.body['count']);
          if (this.documentCount >= this.offset + 200) {
            this.loadNext = true;
          }
          if (this.offset >= 200) {
            this.loadPrevious = true;
          }
          for (const data of resp.body["results"]) {
            this.searchResults.push(data);
          }
          this.documentCount = this.documents.results.length;
          this.indexDocList = new MatTableDataSource(this.documents.results);
          // this.indexDocList.sort = this.sort;
          this.indexDocList.paginator = this.paginator;
          this.setPagesArray(false);
          this.fetchMetaDataProperties();
        }
      },
        error => {
          var errObj = JSON.parse(error.error)
          if (error.error['status'] = 400) {
            this.appError = errObj.message
          }
      });
  }


  async executeSearch(limit, offset, isNextButton) {
    this.closeTabs(true);
    if (isNextButton) {
      this.noDocuments = false;            
      //populate search request
      let searchCriteria = [];
      
      var nextSearchReq = {
        "searchformId": String(this.searchForms.id),
        "limit": limit,
        "offset": offset,
        "storage_class": "S3",
        "criteria": []
      };
      if (this.showArchived) {
        nextSearchReq.storage_class = "Glacier";
      }

      searchCriteria.push(nextSearchReq.criteria)
      this.displayList.forEach(data => {
        if (data['values'] && data['values'] !== "") {          
          let filterList = this.searchForms.form.filter(form => form['label'].toLowerCase().includes(data['Property Name'].toLowerCase()));
          let filterCriteria = filterList[0];
          var d = JSON.parse(JSON.stringify(data))
          var criterion = new SearchCriterion();
          criterion.bindingName = filterCriteria.bindingName;
          criterion.value = d.values;
          criterion["case_insensitive"] = this.isCaseInsensitive;
          if (filterCriteria.UIControl == "Date") {
            var dateArray = criterion.value.split("-");
            var date = dateArray[1] + "/" + dateArray[2] + "/" + dateArray[0];
            criterion.value = date;
          }
          if (d.Type == 'bool') {
            criterion.value = "" + criterion.value;
          }
          //criterion["case_insensitive"]= false;
          nextSearchReq.criteria.push(criterion);
        }
      });
      this.apiSvc.getSearchResults(nextSearchReq)
      .subscribe(resp => {
        console.log("Response", resp)
        if (resp.body == "No search results found") {
          this.alertService.error("No documents found");
        }
        else {
          this.noDocuments = false;
          // this.documents['count'] += documents['count'];
          let documents = resp.body;
          this.documents['offset'] = documents['offset'];
          this.documentCount += documents.results.length;       
          documents.results.forEach(result => {
            this.documents.results.push(result);
          });          
          // this.category = this.documents.properties; 
          this.indexDocList = new MatTableDataSource(this.documents.results);
          // this.indexDocList.sort = this.sort;
          this.indexDocList.paginator = this.paginator;
          this.setPagesArray(isNextButton);
          this.fetchMetaDataProperties();
        }
      },
        error => {
          var errObj = JSON.parse(error.error)
          if (error.error['status'] = 400) {
            this.appError = errObj.message
          }
        });
      
    } else {
      this.noDocuments = true;
      this.documentCount = 0;
      this.documents = [];
      let searchCriteria = [];
      this.deselectAll();
      // let currentForms = this.getForms();
            
      //populate search request
      
      this.offset = 0;
      var searchReq = {
        "searchformId": String(this.searchForms.id),
        "offset": this.offset,
        "limit": 200,
        "storage_class": "S3",
        "criteria": []
      };
      if (this.showArchived) {
        searchReq.storage_class = "Glacier";
      }

      // Introduced to automatically populate the water right id field based on the selected counties
      const countyItem = this.displayList.find(item => item['Property Name'] === 'County');
      this.counties = countyItem ? countyItem['values'] : "";
      const hasCountyInput = !!this.counties && this.counties.trim().length > 0;
      const countyFormat = /^[A-Za-z]+(?:\s+[A-Za-z]+)*(?:\s*,\s*[A-Za-z]+(?:\s+[A-Za-z]+)*)*$/;
      const hasValidCountyFormat = hasCountyInput && countyFormat.test(this.counties.trim());
      if (hasCountyInput && !hasValidCountyFormat) {
        this.apiSvc.notify("Invalid county format. Separate counties with commas only.");
        return;
      }

      if (hasValidCountyFormat) {
        const counties: string[] = this.counties.split(",").map(county => county.trim());
        const resp =  await this.apiSvc.getWaterRightIdsByCounty({"county": counties}).toPromise();

        if (resp && resp.length === 0) {
          this.apiSvc.notify("No water right IDs found for the inputted counties.");
          this.alertService.error("No documents found");
          return;
        }

        const waterRightIdItem = this.displayList.find(item => item['Property Name'] === 'Water Right ID');
        if (waterRightIdItem && resp) {
          waterRightIdItem['values'] = resp.join(",");
        }
      }

      searchCriteria.push(searchReq.criteria)
      this.displayList.forEach(data => {
        if (data['values'] && data['values'] !== "" && data['Property Name'] !== 'County') {          
          let filterList = this.searchForms.form.filter(form => form['label'].toLowerCase().includes(data['Property Name'].toLowerCase()));
          let filterCriteria = filterList[0];
          var d = JSON.parse(JSON.stringify(data))
          var criterion = new SearchCriterion();
          criterion.bindingName = filterCriteria.bindingName;
          criterion.value = d.values;
          criterion["case_insensitive"] = this.isCaseInsensitive;
          if (filterCriteria.UIControl == "Date") {
            var dateArray = criterion.value.split("-");
            var date = dateArray[1] + "/" + dateArray[2] + "/" + dateArray[0];
            criterion.value = date;
          }
          if (d.Type == 'bool') {
            criterion.value = "" + criterion.value;
          }
          //criterion["case_insensitive"]= false;
          searchReq.criteria.push(criterion);
        }
      });

       this.apiSvc.getSearchResults(searchReq)
      .subscribe(resp => {
        console.log("Response", resp)
        if (resp.body == "No search results found") {
          this.noSearchResults = true;          
          this.totalSize = 0;
        }
        else {
          this.noDocuments = false;
          this.noSearchResults = false
          this.documents = resp.body;
          this.totalSize = Number(resp.body['count']);
          if (this.documentCount >= this.offset + 200) {
            this.loadNext = true;
          }
          if (this.offset >= 200) {
            this.loadPrevious = true;
          }
          for (const data of resp.body["results"]) {
            this.searchResults.push(data);
          }
          this.documentCount = this.documents.results.length;       
          this.category = this.documents.properties;
          if (localStorage.getItem('additionalColumns') !== null) {
            // check if additionalColumns col name in category is visible:true or not, if not set true
            const additionalColumnNames = JSON.parse(localStorage.getItem('additionalColumns'));
            this.category.forEach(col => {
            if (additionalColumnNames.includes(col.name)) {
              col.visible = true;
            }
          });
          }
          this.headerColumns = JSON.parse(JSON.stringify(this.category));
          this.indexDocList = new MatTableDataSource(this.documents.results);
          // this.indexDocList.sort = this.sort;
          this.indexDocList.paginator = this.paginator;
          this.setPagesArray(isNextButton);
          this.fetchMetaDataProperties();
        }
      },
        error => {
          var errObj = JSON.parse(error.error)
          if (error.error['status'] = 400) {
            this.appError = errObj.message
          }
        });      
    }
    

  }

  next() {
    this.offset += 200;    
    this.executeSearch(this.limit, this.offset , true);
  }

  stringContainsAny(str: string, substrings: string[]): boolean {
    let strArray = str.split(".");
    let extension = '';
    if (strArray.length > 1) {
      extension = '.'+strArray[strArray.length - 1];
    }
    return substrings.some(substring => extension.includes(substring));
  }

  fileView(doc) {    
    const msOfficeFiles = [".doc", ".docx", ".xls", ".xlsx", ".csv", ".ppt", ".pptx", ".dotx", ".dotm",".docm", ".xlsb", ".xlam", ".pst", ".rtf"];
    
    const result = this.stringContainsAny(doc.name, msOfficeFiles);
    if (result) {
      this.documentService.viewDocument(doc.document_id)
        .subscribe(
          resp => {            
            //console.log("View document " + resp);
            var url = resp.slice(5);
            this.httpClient.get(url, { responseType: 'blob' })
            .subscribe(blob => {
              saveAs(blob, doc.name);
            });
          }
        );
    } else {
      this.documentService.viewDocument(doc.document_id)
        .subscribe(
          resp => {            
            //console.log("View document " + resp);
            var url = resp.slice(5);
            //window.open(url);
            window.open(url, '_blank', 'location=yes,height=900,width=900,scrollbars=yes,status=yes');
          }
        );
    }
  }

  setPagesArray(isNextButton) {
    if (isNextButton) {
      this.documents.results.forEach((element, index) => {
        var object = {}
        object['name'] = element.documentName;
        object['document_id'] = element.documentId;
        object['create_date'] = element.createdDate;
        object['created_by'] = element.created_by;
        object['modifiedDate'] = element.modifiedDate;
        object['modified_by'] = element.modified_by;
        object['properties'] = element['meta_data']['properties'];
        object['system'] = element['meta_data']['system'];      
        this.pagesArray.push(Object.assign(object))
  
      });
    } else {
      this.pagesArray = [];
      this.paginationPagesArray = [];      
      this.pageIndex = 0;
      this.pageSize = 50;
      this.currentStartPageIndex = 1;
      this.currentPageSize = 50;
      this.documents.results.forEach((element, index) => {
        var object = {}
        object['name'] = element.documentName;
        object['document_id'] = element.documentId;
        object['create_date'] = element.createdDate;
        object['created_by'] = element.created_by;
        object['modifiedDate'] = element.modifiedDate;
        object['modified_by'] = element.modified_by;
        object['properties'] = element['meta_data']['properties'];
        object['system'] = element['meta_data']['system'];      
        this.pagesArray.push(Object.assign(object))
  
      });
    }
  }

  selectPage(pageOptions) {
    this.closeTabs(true);
    if (this.isFilterSearchEnabled) {
      this.pageIndex = pageOptions.pageIndex;
      this.pageSize = pageOptions.pageSize;
      let currentPageSize = this.pageSize;    
      this.currentStartPageIndex = (this.pageIndex * this.pageSize) + 1;
      currentPageSize = currentPageSize * (this.pageIndex + 1);
      if (currentPageSize >= this.documentCount && currentPageSize < this.filterTotalSize) {     
        this.next();
      }
      this.currentPageSize = currentPageSize;
      this.paginationPagesArray = [];
      for (let i = this.currentStartPageIndex - 1; i < currentPageSize; i++) {
        if (this.pagesArray[i]) {
          this.paginationPagesArray.push(this.pagesArray[i]);
        }
      }      
    } else {
      this.pageIndex = pageOptions.pageIndex;
      this.pageSize = pageOptions.pageSize;
      let currentPageSize = this.pageSize;    
      this.currentStartPageIndex = (this.pageIndex * this.pageSize) + 1;
      currentPageSize = currentPageSize * (this.pageIndex + 1);
      if (currentPageSize >= this.documentCount && currentPageSize < this.totalSize) {     
        this.next();
      }
      this.currentPageSize = currentPageSize;
      this.paginationPagesArray = [];
      for (let i = this.currentStartPageIndex - 1; i < currentPageSize; i++) {
        if (this.pagesArray[i]) {
          this.paginationPagesArray.push(this.pagesArray[i]);
        }
      }      
    }
  }

  fetchMetaDataProperties() {
    // this.setPagesArray()
    this.categoryID = 0;
    this.isCategorySelected = true;    
    this.categoryMetaData = new MatTableDataSource(this.category);    
    this.pagesArray.forEach(element => {
      const propertiesClone = [];
      for (var i = 0; i < this.category.length; i++) {
        this.category.forEach(element => {
          element['value'] = ""
          if (element.data_type == "options" && element.name == "Document Type") {
            element['filteredList'] = element.values.map(val => val.DocumentType).sort();
            element['actualList'] = element.values.map(val => val.DocumentType).sort();
            // element['filteredList'] = this.values.slice();
          } else if (element.data_type == "options" && element.name != "Document Type") {
            element['filteredList'] = element.values.slice().sort();
            element['actualList'] = element.values.slice().sort();
          }
        });
        let properties = element.properties;
        if (properties[this.category[i].name]) {
          this.category[i].value = properties[this.category[i].name];
          if (this.category[i].name == 'Water Right ID' && this.category[i].value) {
            this.category[i].value =  this.category[i].value.toString().replace("[","").replace("]","").replace(/"/g, "");
          }
          if (this.category[i].data_type == 'date' && this.category[i].value != "" && this.category[i].value != undefined) {
            const d = new Date(this.category[i].value);
            const editField = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1);
            let dateString = this.datePipe.transform(editField, 'yyyy-MM-dd');        
            this.category[i].value = dateString;

            // let dateStrFormat = this.category[i].value.split("/");
            // this.category[i].value = dateStrFormat[2] + "-" + dateStrFormat[0] + "-" + dateStrFormat[1];
            // this.category[i].value = new Date(Date.parse(this.category[i].value));
          }
        } else if (properties[this.category[i].name] == '') {
          this.category[i].value = properties[this.category[i].name];
        }
        if (element['properties']['Parent Doc ID'] && element['properties']['Parent Doc ID'] != "" && this.category[i]["name"] == "Parent") {
          this.category[i]["disabled"] = true;
        }
        this.category[i]["error"] = {"flag": false, "message": ""};
        propertiesClone.push(Object.assign({}, this.category[i]));        
        // if (this.category[i]['visible'] == true) {
        // }
      }      
      element.objValues = propertiesClone;
    })

    this.values = Object.assign(this.category)
    this.category.forEach((element, index) => {
      if (element.data_type == "date") {
        if (this.values[element.name] == '' || this.values[element.name] == null) {

        } else {
          var dateArray = this.values[element.name].split("/")
          var date = dateArray[2] + "-" + dateArray[0] + "-" + dateArray[1]
          this.values[element.name] = date
        }
      }
    });
    this.properties = {}
    this.propertyKeys.forEach(key => {
      if (this.values[String(key)]) {
        this.properties[String(key)] = this.values[String(key)]
      } else {
        this.properties[String(key)] = undefined
      }
    })

    this.paginationPagesArray = [];
    this.tableData = new MatTableDataSource(this.pagesArray);
    for (let i = this.currentStartPageIndex - 1; i < this.currentPageSize; i++) {
      if (this.pagesArray[i]) {
        this.paginationPagesArray.push(this.pagesArray[i]);
      }
    }    
    this.setFormArray();
  }

  updateColumns() {
    this.categoryID = 0;
    this.isCategorySelected = true;    
    this.categoryMetaData = new MatTableDataSource(this.category);    
    this.additionalColumns = this.category.filter(col => col.visible && !this.staticColumns.includes(col.name))
    .map(col => col.name);     
    localStorage.setItem('additionalColumns', JSON.stringify(this.additionalColumns));
    this.pagesArray.forEach(element => {
      const propertiesClone = [];
      for (var i = 0; i < this.category.length; i++) {
        this.category.forEach(element => {
          element['value'] = ""
          if (element.data_type == "options" && element.name == "Document Type") {
            element['filteredList'] = element.values.map(val => val.DocumentType).sort();
            element['actualList'] = element.values.map(val => val.DocumentType).sort();
            // element['filteredList'] = this.values.slice();
          } else if (element.data_type == "options" && element.name != "Document Type") {
            element['filteredList'] = element.values.slice().sort();
            element['actualList'] = element.values.slice().sort();
          }
        });
        let properties = element.properties;
        if (properties[this.category[i].name]) {
          this.category[i].value = properties[this.category[i].name];
          if (this.category[i].name == 'Water Right ID' && this.category[i].value) {
            this.category[i].value =  this.category[i].value.toString().replace("[","").replace("]","").replace(/"/g, "");
          }
          if (this.category[i].data_type == 'date' && this.category[i].value != "" && this.category[i].value != undefined) {
            const d = new Date(this.category[i].value);
            const editField = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1);
            let dateString = this.datePipe.transform(editField, 'yyyy-MM-dd');        
            this.category[i].value = dateString;

            // let dateStrFormat = this.category[i].value.split("/");
            // this.category[i].value = dateStrFormat[2] + "-" + dateStrFormat[0] + "-" + dateStrFormat[1];
            // this.category[i].value = new Date(Date.parse(this.category[i].value));
          }
        } else if (properties[this.category[i].name] == '') {
          this.category[i].value = properties[this.category[i].name];
        }
        if (element['properties']['Parent Doc ID'] && element['properties']['Parent Doc ID'] != "" && this.category[i]["name"] == "Parent") {
          this.category[i]["disabled"] = true;
        }
        this.category[i]["error"] = {"flag": false, "message": ""};
        propertiesClone.push(Object.assign({}, this.category[i]));        
        // if (this.category[i]['visible'] == true) {
        // }
      }      
      element.objValues = propertiesClone;
    })

    this.values = Object.assign(this.category)
    this.category.forEach((element, index) => {
      if (element.data_type == "date") {
        if (this.values[element.name] == '' || this.values[element.name] == null) {

        } else {
          var dateArray = this.values[element.name].split("/")
          var date = dateArray[2] + "-" + dateArray[0] + "-" + dateArray[1]
          this.values[element.name] = date
        }
      }
    });
    this.properties = {}
    this.propertyKeys.forEach(key => {
      if (this.values[String(key)]) {
        this.properties[String(key)] = this.values[String(key)]
      } else {
        this.properties[String(key)] = undefined
      }
    })

    this.paginationPagesArray = [];
    this.tableData = new MatTableDataSource(this.pagesArray);
    for (let i = this.currentStartPageIndex - 1; i < this.currentPageSize; i++) {
      if (this.pagesArray[i]) {
        this.paginationPagesArray.push(this.pagesArray[i]);
      }
    }    
    this.setFormArray();
    this.headerColumns = JSON.parse(JSON.stringify(this.category)); 
  }

  applyFilter(event: Event, column) {
    this.filterValue = (event.target as HTMLInputElement).value;
    this.isFilterSearchEnabled = true;   
    if (this.filterValue || this.filterValue !== "") {
      this.filterSearch(this.filterValue, column);
    } else {
      // this.tempPagesArray = this.paginationPagesArray;
      function removeValue(criteria, index, arr) {

          if (criteria.bindingName.toLowerCase() === column.toLowerCase()) {
          // Removes the value from the original array
              arr.splice(index, 1);
              return true;
          }
          return false;
      }

        // Pass the removeValue function into the filter function to return the specified value
      if (this.columnFilterCriteria.length > 0) {
        this.columnFilterCriteria.filter(removeValue);        
      }


      this.filterSearch(this.filterValue, column);
    }
  }

  checkBoxChecked(column, tabName) {
    var actualColumnName = column + tabName;
    var checkboxvalue = <HTMLInputElement>document.getElementById(actualColumnName);
    var isChecked = checkboxvalue.checked;
    if (isChecked) {
      this.selectedColumnList.push(column);
    } else {
      const index = this.selectedColumnList.indexOf(column);
      if (index > -1) {
        this.selectedColumnList.splice(index, 1);
      }
    }
  }
  openUpdateMetaData(document_id) {
    this.closeTabs(true);
    this.documentService.getDocumentDetails(document_id)
    .subscribe(details => {
        this.openMetaData = true;
        this.hideDocView = false;
        this.activeDocumentDetails = details;       
      });
  }

  closeTabs(hide: boolean) {
    if (hide) {
      this.openMetaData = false;      
    }
  }

  backFromMetaData(hide: boolean) {
    if (hide) {
      this.openMetaData = true;
    }
    else {
      this.openMetaData = false;
      this.ngOnInit();
      //this.selectedDoc.VersionNumber = this.activeDocumentDetails.activeVersion + 1
    }
  }
  
  copy() {
    if (this.selectedColumnList.length == 0) {
      this.alertService.error("Please select a single column to copy data");
            setTimeout(() => {    
              this.alertService.clear();          
            }, 5000);
      return;
    }
    if (this.selection.selected.length > 1) {
      this.alertService.error("Please select a single row to copy data from the selected row to the selected column");
            setTimeout(() => {
              this.alertService.clear();         
            }, 5000);
      return;
    }
    let selectedList = this.selection.selected;
    let updateList = selectedList.filter(row => this.pagesArray.map(value => value.document_id).includes(row.document_id));
    var selectedRow = null;
    if (updateList.length > 0) {
      selectedRow = updateList[0];
    } else {
      return;
    }
    let limit = this.totalSize;
    if (this.filterTotalSize > 0) {
      limit = this.filterTotalSize;
    }
    if (limit > this.isBulkUpdateAsyncLimit && !this.isAdmin){
      this.alertService.success("Document count for update has exceeded the limit of " + this.isBulkUpdateAsyncLimit + ". Please contact administrator to perform this operation.");
            setTimeout(() => {              
            }, 2000);
      return;
    }
    let dialogRef = this.dialog.open(ConfirmDialogComponent,
      { data: { columnList: this.selectedColumnList, count: limit} });
      dialogRef.afterClosed().subscribe(result => {
        if (result == 'Y') {
            let updateValues = {};
            for (let column of this.selectedColumnList) {
              var tempValue = null;
              selectedRow['objValues'].forEach(element => {
                if (element.name == column && !element["error"]["flag"]) {
                  tempValue = element.value
                }
              });
              if (tempValue || tempValue == false) {
                  updateValues[column] = tempValue;
                  if (column == MARK_FOR_DELETE_KEY) {
                    if (tempValue == true) {
                      const metadataComment = this.latestComments.find(mtdCom => mtdCom.metadataName === REASON_FOR_DELETE_KEY)
                      if (metadataComment != undefined)
                        updateValues[REASON_FOR_DELETE_KEY] = metadataComment.comment;
                    }
                    else
                      updateValues[REASON_FOR_DELETE_KEY] = '';
                  }
              }
            }
            let searchCriteria = [];
            
            var copyRequest = {
              "searchformId": this.searchForms.id,
              "limit": limit,
              "offset": 0,
              "storage_class": "S3",
              "criteria": [],
              "updateValues": updateValues,
              "ignoreLockedStatus": true
            };

            if (this.showArchived) {
              copyRequest.storage_class = "Glacier";
            }
            searchCriteria.push(copyRequest.criteria)
            this.displayList.forEach(data => {
              if (data['values'] && data['values'] !== "") {          
                let filterList = this.searchForms.form.filter(form => form['label'].toLowerCase().includes(data['Property Name'].toLowerCase()));
                let filterCriteria = filterList[0];
                var d = JSON.parse(JSON.stringify(data))
                var criterion = new SearchCriterion();
                criterion.bindingName = filterCriteria.bindingName;
                criterion.value = d.values;
                criterion["case_insensitive"] = this.isCaseInsensitive
                if (filterCriteria.UIControl == "Date") {
                  var dateArray = criterion.value.split("-")
                  var date = dateArray[1] + "/" + dateArray[2] + "/" + dateArray[0]
                  criterion.value = date
                }
                if (d.Type == 'bool') {
                  criterion.value = "" + criterion.value;
                }
                //criterion["case_insensitive"]= false;
                copyRequest.criteria.push(criterion);
              }
            }); 
            
            if (this.columnFilterCriteria.length > 0) {
                this.columnFilterCriteria.forEach(crit => {
                  copyRequest.criteria.push(crit);
                });
            }
            this.documentService.copyMetadata(copyRequest).subscribe(response => {      
              if (limit > this.isBulkUpdateAsyncLimit && this.isAdmin){
                this.snackBar.open(
                  "Bulk update request is running in the background. The status of bulk update can be tracked from 'Status' tab",
                  'Close',
                  {
                    duration: 10000,
                  }
                );
              } else {
                this.alertService.success("Documents are updated successfully");
              }
              setTimeout(() => {              
                this.selectedColumnList = [];
                this.executeSearch(200, 0, false);
              }, 2000);
            }, error => {
              this.alertService.error("Server error, update is failed");
              this.selectedColumnList = [];
              this.deselectAll();
            })
          } else if (result == 'P') {
             this.preview(limit, 0, selectedRow);
          } else {
            console.log("Opted for N operation");
          }
    });
    
  }


  setFormArray() {
    if (this.pagesForm) {
      let arr = this.pagesForm.controls.arr;
      this.pagesArray.forEach(x => {
        (arr as FormArray).push(this.fb.group({
          name: x.name
        }))
      })
    }
  }


  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.indexDocList.data.length;
    return numSelected === numRows;
  }

  masterToggle(ref) {
    if (this.isSomeSelected()) {

      this.selection.clear();
      ref.checked = false;

    } else {
      this.isAllSelected() ?
        this.selection.clear() :
        this.selecteAll();
    }
  }

  isSomeSelected() {
    return this.selection.selected.length > 0;
  }


  selecteAll() {
    if (this.filterValue) {
      this.indexDocList.filter = this.filterValue.trim().toLowerCase();
      //console.log(this.allPurgeList.filteredData)
      this.indexDocList.filteredData.forEach(row => {
        this.selection.select(row.documentId)
      });
    }
    else {
      this.indexDocList.data.forEach(row => this.selection.select(row.documentId));
    }
  }

  preview(limit, offset, selectedRow) {
    this.noDocuments = true;
    this.documentCount = 0;
    this.documents = [];
    let searchCriteria = [];
    this.deselectAll();
    // let currentForms = this.getForms();
          
    //populate search request
        
    var searchReq = {
      "searchformId": String(this.searchForms.id),
      "offset": offset,
      "limit": limit,
      "storage_class": "S3",
      "criteria": []
    };
    if (this.showArchived) {
      searchReq.storage_class = "Glacier";
    }
    searchCriteria.push(searchReq.criteria)
    this.displayList.forEach(data => {
      if (data['values'] && data['values'] !== "") {          
        let filterList = this.searchForms.form.filter(form => form['label'].toLowerCase().includes(data['Property Name'].toLowerCase()));
        let filterCriteria = filterList[0];
        var d = JSON.parse(JSON.stringify(data))
        var criterion = new SearchCriterion();
        criterion.bindingName = filterCriteria.bindingName;
        criterion.value = d.values;
        criterion["case_insensitive"] = this.isCaseInsensitive;
        if (filterCriteria.UIControl == "Date") {
          var dateArray = criterion.value.split("-");
          var date = dateArray[1] + "/" + dateArray[2] + "/" + dateArray[0];
          criterion.value = date;
        }
        if (d.Type == 'bool') {
          criterion.value = "" + criterion.value;
        }
        //criterion["case_insensitive"]= false;
        searchReq.criteria.push(criterion);
      }
    });

      this.apiSvc.getSearchResults(searchReq)
        .subscribe(resp => {
        console.log("Response", resp)
        if (resp.body == "No search results found") {
          this.noSearchResults = true;          
          this.totalSize = 0;
        }
        else {
          this.noDocuments = false;
          this.noSearchResults = false
          this.documents = resp.body;
          this.totalSize = Number(resp.body['count']);

          if (this.documentCount >= this.offset + 200) {
            this.loadNext = true;
          }
          if (this.offset >= 200) {
            this.loadPrevious = true;
          }
          for (const data of resp.body["results"]) {
            this.searchResults.push(data);
          }
          this.documentCount = this.documents.results.length;       
          this.category = this.documents.properties;
          if (localStorage.getItem('additionalColumns') !== null) {
            // check if additionalColumns col name in category is visible:true or not, if not set true
            const additionalColumnNames = JSON.parse(localStorage.getItem('additionalColumns'));
            this.category.forEach(col => {
            if (additionalColumnNames.includes(col.name)) {
              col.visible = true;
            }
          });
          }
          this.headerColumns = JSON.parse(JSON.stringify(this.category));
          this.indexDocList = new MatTableDataSource(this.documents.results);
          // this.indexDocList.sort = this.sort;
          this.indexDocList.paginator = this.paginator;
          this.setPagesArray(false);
          this.fetchMetaDataProperties();
          var tempValue = null;
          for (let column of this.selectedColumnList) {
            selectedRow['objValues'].forEach(element => {
            if (element.name == column && !element["error"]["flag"]) {
              tempValue = element.value
            }
            });
            if (tempValue || tempValue == false) {
              this.pagesArray.forEach(element => {
                element['objValues'].forEach(property => {
                  if (property.name == column) {                    
                    if (property.data_type == "Date") {
                      var dateArray = tempValue.value.split("-");
                      var date = dateArray[1] + "/" + dateArray[2] + "/" + dateArray[0];
                      property.value = date;
                    } else if (column == "Water Right ID") {  
                      if (!property.value) {
                        property.value = tempValue;
                      } else if (property.value) {
                        let wrList = tempValue.split(",");
                        if (wrList.length > 1) {
                          wrList.forEach(wr => {
                            if (!property.value.includes(wr)) { 
                              property.value += "," + wr;
                            }
                          });
                        } else {
                          if (!property.value.includes(tempValue)) { 
                            property.value += "," + tempValue;
                          }
                        }
                      }
                    } else if (COMMENT_APPLICABLE_METADATA_KEYS.includes(column)) {
                      this.setBulkComment(column, element)
                      property.value = tempValue;
                    } else if (column === MARK_FOR_DELETE_KEY) {
                      // Sets the Reason for Delete comment for the associated Mark for Delete
                      this.setBulkDeleteComment(element);
                      property.value = tempValue;
                    } else {
                      property.value = tempValue;
                    }
                  }                 
                });
              });
            }
          }
          this.selectAll();
          this.selectedColumnList = [];         
        }
    },
    error => {
      var errObj = JSON.parse(error.error)
      if (error.error['status'] = 400) {
        this.appError = errObj.message
      }
    });    
  }

    exportDocumentLink() {

    let selectedList = this.selection.selected;
    let updatedList = selectedList.filter(row => this.pagesArray.map(value => value.document_id).includes(row.document_id));
    let docIdList = []

    updatedList.forEach(element => {
      docIdList.push(element["document_id"])
    });

    let totalList = [];
    var request;
    if (updatedList.length > 100) {
      request = {
        "document_ids": totalList,
        "expiration_time": this.exportExpiration,
        "searchformId": String(this.selectedForm.id),
        "offset": 0,
        "limit": this.totalSize,
        "storage_class": "S3",
        "criteria": [],
        "async": true,
      };
      this.searchCriteria = []
      this.searchCriteria.push(request.criteria)
      //populate search request

      if (this.showArchived) {
        request.storage_class = "Glacier";
      }

      for (const item of this.displayList) {
        if (item["values"]) {
          const form = this.selectedForm.form.find(f => f.label === item["Property Name"]);
          var criterion = new SearchCriterion();
          criterion.bindingName = form?.bindingName;
          criterion.value = item["values"];
          if (item["Type"] == "date") {
            var dateArray = criterion.value.split("-")
            var date = dateArray[1] + "/" + dateArray[2] + "/" + dateArray[0]
            criterion.value = date
          }
          criterion["case_insensitive"] = true;
          request.criteria.push(criterion);
        }
      }
    } else {
      totalList = docIdList;
      request = {
        "document_ids": totalList,
        "expiration_time": this.exportExpiration,
        "async": true
      }
    }
    this.selection.clear();
    this.documentService.exportDocumentsLink(request).subscribe(
      response => {
        this.isExportLink=true;
        console.log("Response " + response);
      });

  }

  exportDocuments() {

    let selectedList = this.selection.selected;
    let updatedList = selectedList.filter(row => this.pagesArray.map(value => value.document_id).includes(row.document_id));
    let docIdList = []

    updatedList.forEach(element => {
      docIdList.push(element["document_id"])
    });

    var request;
    if (selectedList.length > 100) {
      request = {
        "docid": docIdList,
        "searchformId": String(this.selectedForm.id),
        "offset": 0,
        "limit": this.totalSize,
        "storage_class": "S3",
        "criteria": [],
        "async": true,
      };
      this.searchCriteria = []
      this.searchCriteria.push(request.criteria)
      //populate search request

      if (this.showArchived) {
        request.storage_class = "Glacier";
      }
      for (const item of this.displayList) {
        if (item["values"]) {
          const form = this.selectedForm.form.find(f => f.label === item["Property Name"]);
          var criterion = new SearchCriterion();
          criterion.bindingName = form?.bindingName;
          criterion.value = item["values"];
          if (item["Type"] == "date") {
            var dateArray = criterion.value.split("-")
            var date = dateArray[1] + "/" + dateArray[2] + "/" + dateArray[0]
            criterion.value = date
          }
          criterion["case_insensitive"] = true;
          request.criteria.push(criterion);
        }
      }
    } else {
      request = {
        "docid": docIdList,
        "async": true
      }
    }
    this.selection.clear();
    this.documentService.exportDocuments(request).subscribe(
      response => {
        console.log("Response " + response);
      });
  }

  openDialog(fieldName: any, documentId: any, document: any): void {
    let index: number;
    let update: boolean = false;
    let dialogRef = this.dialog.open(PopUpComponent, {
      disableClose: true,
      width: '500px',
      data: { comment: this.comment, message: 'Please enter a comment for this change (no more than ' + MAX_CHARS + ' characters:' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.comment = result.comment.trim();
        const metadataComment = this.latestComments.find(mtdCom => mtdCom.metadataName === fieldName)
        if (metadataComment === undefined)
          this.latestComments.push({metadataName: fieldName, comment: this.comment})
        else
          metadataComment.comment = this.comment;

        let key = fieldName + COMMENT_APPENDER;
        let currentPortalUserInfo = document.objValues.find(key => key.name === PORTAL_USER_INFO_KEY);
        let currentPortalUserInfoObj: any = {};
        this.portalUserInfo = {}

        if (currentPortalUserInfo.value != '')
          currentPortalUserInfoObj = JSON.parse(JSON.stringify(currentPortalUserInfo.value))

        if (this.portalUserInfo.constructor === Object && Object.keys(this.portalUserInfo).length === 0) {
          this.portalUserInfo = JSON.parse(JSON.stringify(currentPortalUserInfoObj))
        }
        
        if(this.portalUserInfoByDocumentId.length > 0) {
            index = this.portalUserInfoByDocumentId.findIndex(obj => documentId in obj);
          if (index != -1 && index !== undefined) {
            const [innerData] = Object.values(this.portalUserInfoByDocumentId[index])
            this.portalUserInfo = innerData;
            update = true;
          }
        }

        if (this.comment.trim() != '') {
          if (this.portalUserInfo[key] && Object.keys(currentPortalUserInfoObj).length > 0) {
            let num = currentPortalUserInfoObj[key]?.length;
            let versions = Number.isNaN(num) || num === undefined ? 0: num;
            if (this.portalUserInfo[key].length > versions)
              this.portalUserInfo[key][versions] = {comment: this.comment, version: (versions + 1)}
            else {
              this.portalUserInfo[key].push({
                comment: this.comment,
                version: ++versions
              });
            }
          } else {
            this.portalUserInfo[key] = []
            this.portalUserInfo[key].push({
              comment: this.comment,
              version: 1
            });
          }
        }

        var documentIdObj: Record<string, any> = {
          [documentId]: this.portalUserInfo
        };

        if (update)
          this.portalUserInfoByDocumentId[index] = documentIdObj
        else
          this.portalUserInfoByDocumentId.push(documentIdObj)
        console.log(this.portalUserInfoByDocumentId)
      }
    });
  }

  // In case users attempt to make more changes without leaving the page
  resetComments() {
    this.portalUserInfo = {}
    this.portalUserInfoByDocumentId = []
  }

  setBulkComment(column: any, document: any) {

    let index: number;
    let update: boolean = false;

    let metadataComment = this.latestComments.find(mtdCom => mtdCom.metadataName === column)
    if (metadataComment === undefined) {
      metadataComment = {
        metadataName: column,
        comment: "Updated as part of Bulk Metadata Update process through Copy - a comment was not provided"
      }
    }
    console.log(this.latestComments);

    let key = column + COMMENT_APPENDER;
    let currentPortalUserInfo = document.objValues.find(key => key.name === PORTAL_USER_INFO_KEY);
    let currentPortalUserInfoObj: any = {};
    this.portalUserInfo = {}

    if (currentPortalUserInfo.value != '')
      currentPortalUserInfoObj = JSON.parse(JSON.stringify(currentPortalUserInfo.value))

    if (this.portalUserInfo.constructor === Object && Object.keys(this.portalUserInfo).length === 0) {
      this.portalUserInfo = JSON.parse(JSON.stringify(currentPortalUserInfoObj))
    }
    
    if(this.portalUserInfoByDocumentId.length > 0) {
        index = this.portalUserInfoByDocumentId.findIndex(obj => document.document_id in obj);
      if (index != -1 && index !== undefined) {
        const [innerData] = Object.values(this.portalUserInfoByDocumentId[index])
        this.portalUserInfo = innerData;
        update = true;
      }
    }

    if (this.portalUserInfo[key] && Object.keys(currentPortalUserInfoObj).length > 0) {
      let num = currentPortalUserInfoObj[key]?.length;
      let versions = Number.isNaN(num) || num === undefined ? 0: num;
      if (this.portalUserInfo[key].length > versions)
        this.portalUserInfo[key][versions] = {comment: metadataComment.comment, version: (versions + 1)}
      else {
        this.portalUserInfo[key].push({
          comment: metadataComment.comment,
          version: ++versions
        });
      }
    } else {
      this.portalUserInfo[key] = []
      this.portalUserInfo[key].push({
        comment: this.comment,
        version: 1
      });
    }

    var documentIdObj: Record<string, any> = {
      [document.document_id]: this.portalUserInfo
    };

    if (update)
      this.portalUserInfoByDocumentId[index] = documentIdObj
    else
      this.portalUserInfoByDocumentId.push(documentIdObj)
    console.log(this.portalUserInfoByDocumentId)
  }

  openDeleteDialog(document: any): void {
    let index: number;
    let update: boolean = false;
    let dialogRef = this.dialog.open(PopUpComponent, {
      disableClose: true,
      width: '500px',
      data: { comment: this.comment, message: REASON_FOR_DELETE_PROMPT }
    });

    dialogRef.afterClosed().subscribe(result => {
      const metadataComment = this.latestComments.find(mtdCom => mtdCom.metadataName === REASON_FOR_DELETE_KEY)
      if (metadataComment === undefined)
        this.latestComments.push({metadataName: REASON_FOR_DELETE_KEY, comment: result.comment.trim()})
      else
        metadataComment.comment = result.comment.trim();

      let reasonForDelete = document.objValues.find(key => key.name === REASON_FOR_DELETE_KEY);
      if (reasonForDelete && Object.keys(reasonForDelete).length > 0) {
        // Sets Reason for Delete value for specific document
        reasonForDelete.value = result.comment.trim();


        // Create an object to update the tracker in case multiple mark for delete changes have occured
        var documentIdObj: Record<string, any> = {
          [document.document_id]: result.comment.trim()
        };

        if(this.reasonForDeleteByDocumentId.length > 0) {
            index = this.reasonForDeleteByDocumentId.findIndex(obj => document.document_id in obj);
          if (index != -1 && index !== undefined) {
            update = true;
          }
        }

        if (update)
          this.reasonForDeleteByDocumentId[index] = documentIdObj
        else
          this.reasonForDeleteByDocumentId.push(documentIdObj)
      }
    })
  }

  // The latest comment for Reason for Delete will be used for all previewed items
  setBulkDeleteComment(document: any) {
    if (this.reasonForDeleteByDocumentId.length > 0) {
      let reasonForDelete = this.reasonForDeleteByDocumentId.find(obj => Object.keys(obj).includes(document.document_id));
      const metadataComment = this.latestComments.find(mtdCom => mtdCom.metadataName === REASON_FOR_DELETE_KEY)
      if (reasonForDelete && Object.keys(reasonForDelete).length > 0) {
        console.log(reasonForDelete)
        reasonForDelete[document.document_id] = metadataComment?.comment;
      } else {
        this.reasonForDeleteByDocumentId.push({
          [document.document_id]: metadataComment?.comment
        })
      }
    }
    console.log(this.reasonForDeleteByDocumentId);
  }
}
